import { filter } from 'rxjs/operators';
import { MonoTypeOperatorFunction } from 'rxjs';

import { ModalTypes } from '../models/modal-types.enum';

export function ofModalType(modalType: ModalTypes): MonoTypeOperatorFunction<ModalTypes> {
  return filter(v => v === modalType);
}
